import { Icon } from "@iconify/react";

import "./ProjectItem.css";

const ProjectCard = ({ title, technology, image, icons, links }) => {
	// console.log(icons, links);
	return (
		<div className="card card-project">
			<img src={image} className="img-card-project" alt={title} />
			<div className="proj-txtx">
				<h4>{title}</h4>
				<span>{technology}</span>
				<div className="mt-3">
					{Object.keys(links).map(
						(data, key) =>
							links[data] && (
								<a href={links[data]} key={key} target="_blank" rel="noopener noreferrer">
									<Icon icon={icons[data]} className="icon-project mx-1" />
								</a>
							),
					)}
				</div>
			</div>
		</div>
	);
};

export default ProjectCard;
